import { filtersHelper } from '@/utils';

export const propertyAreaUnitModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    isStatistic: data.is_statistic,
    conversionFactor: data.conversion_factor,
    isBase: data.is_base,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
});
